<template>
<div>
  <v-card flat>
    <v-card-text>
      <v-container fluid>
        <!-- {{filters}} -->
        <!-- {{filtered_artworks.length}} -->

        <!-- <h3>Classification {{classification}}</h3>
        <v-layout row wrap>
          <v-flex xs4 sm4 md4>
            <v-switch label="" v-model="filters" value="classification" hide-details></v-switch>
          </v-flex>
          <v-flex xs8 sm4 md4 v-if="filters.indexOf('classification')> -1">
            <v-switch label="PPPD" v-model="classification" value="pppd" hide-details></v-switch>
            <v-switch label="FVS"  v-model="classification" value="fvs" hide-details></v-switch>
            <v-switch label="IAO"  v-model="classification" value="iao" hide-details></v-switch>
            <v-switch label="FURN" v-model="classification" value="furn" hide-details></v-switch>
            <v-switch label="ARCH" v-model="classification" value="arch" hide-details></v-switch>
          </v-flex>
        </v-layout>
        
        <h3>Accession Number {{accession_number}}</h3>
        <v-layout row wrap>
          <v-flex xs4 sm4 md4>
            <v-switch label="" v-model="filters" value="accession_number" hide-details></v-switch>
          </v-flex>
          <v-flex xs8 sm4 md4 v-if="filters.indexOf('accession_number')> -1">
            <v-text-field 
              label="" 
              v-model="accession_number" 
              value="accession_number">
            </v-text-field>
          </v-flex>
        </v-layout> -->

        <!-- <h3>Category {{category}}</h3>
        <v-layout row wrap>
          <v-flex xs4 sm4 md4>
            <v-switch label="" v-model="filters" value="category"></v-switch>
          </v-flex>
          <v-flex xs8 sm4 md4 v-if="filters.indexOf('category')>-1">
            <v-switch label="master" v-model="category" value="master" hide-details></v-switch>
            <v-switch label="master_family"  v-model="category" value="master_family" hide-details></v-switch>
            <v-switch label="private"  v-model="category" value="private" hide-details></v-switch>
            <v-switch label="deaccession" v-model="category" value="deaccession" hide-details></v-switch>
            <v-switch label="to_sort" v-model="category" value="to_sort" hide-details></v-switch>
            <v-switch label="tml_composition" v-model="category" value="tml_composition" hide-details></v-switch>
          </v-flex>
        </v-layout>

        <p>ownership {{s_ownership}}</p>
        <v-layout row wrap>
          <v-flex xs12 sm4 md4>
            <v-switch v-for="ownership in ownerships" 
              v-model="s_ownership"
              v-bind:value="ownership" 
              v-bind:label="ownership" 
              v-bind:key="ownership" hide-details>
            </v-switch>
          </v-flex>
        </v-layout> -->

      </v-container>
    </v-card-text>
  </v-card>

</div>
</template>

<script>
import FilterCheckbox from './FilterCheckbox'

export default {
  data () {
    return {
      filteredProperty: 'title',
      query: '',
      activeFilters: [],
      filters: ['classification'],
      s_ownership: [],
      classification: ['fvs'],
      ownership: [],
      category: [],
      accession_number: []
    }
  },
  components: {
    FilterCheckbox
  },
  computed: {
    filtered_artworks () {
      var a = this.$store.state.artworks
      var filtered = a
      var t = this
      // console.log(this.filters)
      this.filters.forEach(filter => {
        var filter_value = eval('t.' + filter)
        // console.log('filtered_artworks')
        filtered = filtered.filter(record => {
          // console.log(filter)
          // console.log(record[filter])
          // console.log('filterr = ' + filter_value)
          // return true
          return filter === 'accession_number'
            ? new RegExp(filter_value, 'i').test(record[filter])
            : filter_value.some(r=> record[filter].includes(r))
        })
      })
      this.$store.dispatch('postFilterResults', filtered)
      return filtered
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/artworks/FilterBox.vue